import queryString from 'query-string';

export const getQueryParam = <T extends string | Array<string> | undefined>(key: string) => {
  const params = queryString.parse(window.location.search);
  const keyMatch =
    Object.keys(params).find(x => x.toLowerCase() === (key || '').toLowerCase()) || '';

  return params[keyMatch] as T;
};
